import * as React from 'react';

interface SlideArrowSymbolProps {
  className?: string;
  pointLeft?: boolean;
  onClick?: (e:any)=> void;
}

export const SlideArrowSymbol = (props:SlideArrowSymbolProps) => (
<svg width="63.1" className={props.className} onClick={props.onClick} x="0px" y="0px" viewBox="0 0 42.7 30.5">
  <path transform={`rotate(${props.pointLeft ? '-180' : '0'}, 21, 15)`}
    fill="#0067C5" d="M26.6,2.3l-2.5,2.5l8.1,8.1L3.6,13v3.5h28.7l-8.1,8.1l2.5,2.5l12.4-12.4L26.6,2.3z"/>
</svg>);
